module.exports = __webpack_public_path__ + "static/media/sc1.ac294c9a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/sc1.png
// module id = 106
// module chunks = 0